import { ReactElement } from 'react';

/** Non-interactive group label inside the Options block — visually distinct from the accordion headers. */
export default function GroupHeader({ label }: { label: string }): ReactElement {
  return (
    <div className="cr-mt-6 cr-flex cr-items-center cr-gap-3">
      <span className="cr-text-xs cr-font-semibold cr-uppercase cr-tracking-wider cr-text-gray-400">{label}</span>
      <div className="cr-h-px cr-flex-1 cr-bg-gray-200" />
    </div>
  );
}
